{
  "abi": [
    {
      "type": "constructor",
      "inputs": [
        {
          "name": "registry",
          "type": "address",
          "internalType": "contract IRegistry"
        },
        {
          "name": "factory",
          "type": "address",
          "internalType": "contract IxPNTsFactory"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "REGISTRY",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "contract IRegistry"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "XPNTS_FACTORY",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "contract IxPNTsFactory"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "facilitatorEarnings",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "facilitatorFeeBPS",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getEffectiveFacilitatorFee",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "operatorFacilitatorFees",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "owner",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "renounceOwnership",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setFacilitatorFeeBPS",
      "inputs": [
        {
          "name": "_fee",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setOperatorFacilitatorFee",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_fee",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "settleX402Payment",
      "inputs": [
        {
          "name": "from",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "to",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "asset",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "maxFee",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "validAfter",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "validBefore",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "salt",
          "type": "bytes32",
          "internalType": "bytes32"
        },
        {
          "name": "signature",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [
        {
          "name": "settlementId",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "settleX402PaymentDirect",
      "inputs": [
        {
          "name": "from",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "to",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "asset",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "maxFee",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "validBefore",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "nonce",
          "type": "bytes32",
          "internalType": "bytes32"
        },
        {
          "name": "signature",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [
        {
          "name": "settlementId",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "transferOwnership",
      "inputs": [
        {
          "name": "newOwner",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "version",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "pure"
    },
    {
      "type": "function",
      "name": "withdrawFacilitatorEarnings",
      "inputs": [
        {
          "name": "asset",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "x402NonceKey",
      "inputs": [
        {
          "name": "asset",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "from",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "nonce",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "stateMutability": "pure"
    },
    {
      "type": "function",
      "name": "x402SettlementNonces",
      "inputs": [
        {
          "name": "",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "event",
      "name": "FacilitatorEarningsWithdrawn",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "asset",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "FacilitatorFeeUpdated",
      "inputs": [
        {
          "name": "oldFee",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "newFee",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OwnershipTransferred",
      "inputs": [
        {
          "name": "previousOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "X402PaymentSettled",
      "inputs": [
        {
          "name": "from",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "to",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "asset",
          "type": "address",
          "indexed": false,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "fee",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "nonce",
          "type": "bytes32",
          "indexed": false,
          "internalType": "bytes32"
        }
      ],
      "anonymous": false
    },
    {
      "type": "error",
      "name": "AddressEmptyCode",
      "inputs": [
        {
          "name": "target",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "AddressInsufficientBalance",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "FailedInnerCall",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InsufficientBalance",
      "inputs": [
        {
          "name": "available",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "required",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "InvalidConfiguration",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidFee",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidX402Signature",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidXPNTsToken",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NonceAlreadyUsed",
      "inputs": []
    },
    {
      "type": "error",
      "name": "OwnableInvalidOwner",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableUnauthorizedAccount",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ReentrancyGuardReentrantCall",
      "inputs": []
    },
    {
      "type": "error",
      "name": "SafeERC20FailedOperation",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "Unauthorized",
      "inputs": []
    },
    {
      "type": "error",
      "name": "X402AmountMismatch",
      "inputs": []
    },
    {
      "type": "error",
      "name": "X402AuthExpired",
      "inputs": []
    },
    {
      "type": "error",
      "name": "X402FeeExceedsMax",
      "inputs": []
    }
  ],
  "bytecode": "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"
}
